import './errorpage.scss';
import Sloth from '../Sloth';

@Sloth.component({
    defaultOptions: {
        errorcode : 404,
        goto : '/',
        delay : 5
    }
})

export default class Handel404 {
    onInit() {
        if (this.options.errorcode !== 404) {
            return;
        }
        if (this.options.goto !== 'none') {
            setTimeout(() => {
                window.localtion = this.options.goto;
            }, this.options.delay * 1000);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./components/ErrorPage/errorpage.js
 **/